module.exports = __webpack_public_path__ + "static/media/PARCEIROS.61dee975.png";